import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-[70vh] flex items-center justify-center p-6" data-testid="payment-cancel-page">
      <div className="max-w-md w-full text-center rounded-xl border border-zinc-800 bg-zinc-900 p-8">
        <XCircle className="h-12 w-12 text-zinc-500 mx-auto" />
        <h1 className="font-heading text-2xl font-extrabold text-white mt-4">Checkout cancelled</h1>
        <p className="text-zinc-400 text-sm mt-2">No charge was made. You can upgrade any time — your Free plan is still active.</p>
        <button onClick={() => navigate("/billing")} data-testid="cancel-back-btn" className="mt-6 text-sm font-semibold px-5 py-2.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white">
          Back to billing
        </button>
      </div>
    </div>
  );
}
